export default class ClassNameBuilder {
    private classNames: string[] = []

    add(className?: string): this {
        if (className) this.classNames.push(className)
        return this
    }

    addIf(className?: string, condition: boolean = false): this {
        if (condition) return this.add(className)
        return this
    }

    toString() {
        return this.classNames.join(' ').replaceAll(/\s+/g, ' ').trim()
    }
}
